
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Layout 布局</h1>
<p>布局组件，整体页面布局。</p>
<h2 id="zu-jian-gai-shu" class="anchor-title">组件概述 <a class="header-anchor" href="#zu-jian-gai-shu">#</a></h2>
<ul>
<li>
<p><code>Layout</code>组件：布局容器，可以嵌套<code>Header</code> <code>Sider</code> <code>Content</code> <code>Footer</code> <code>Layout</code>组件，可以放在任何父容器中。</p>
</li>
<li>
<p><code>Header</code>组件：顶部容器，可以嵌套在<code>Layout</code>组件中，不能嵌套进其他布局组件中。</p>
</li>
<li>
<p><code>Sider</code>组件：侧边栏容器，默认附带基本功能，可以嵌套在<code>Layout</code>组件中，不能嵌套进其他布局组件中。</p>
</li>
<li>
<p><code>Content</code>组件：内容容器，可以嵌套在<code>Layout</code>组件中，不能嵌套进其他布局组件中。</p>
</li>
<li>
<p><code>Footer</code>组件：底部容器，可以嵌套在<code>Layout</code>组件中，不能嵌套进其他布局组件中。</p>
</li>
</ul>
<h3 id="jiao-hu" class="anchor-title">交互 <a class="header-anchor" href="#jiao-hu">#</a></h3>
<ul>
<li><code>Sider</code>组件实现了基本的侧导航功能，支持手风琴和全展开的样式，请根据业务相应的扩展。</li>
</ul>
<p><Alter type="info" showIcon>注意：采用 flex 布局实现，注意 <a href="https://caniuse.com/#search=flex" target="_blank">浏览器兼容性</a> 的问题。</Alter></p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JBJG">
                <template slot="description"><p>经典的页面布局</p>
</template>
                <template slot="title">基本结构 <a href="#JBJG" data-title="基本结构">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Layout&gt;
        &lt;Header class=&quot;doc-layout-header&quot;&gt;header&lt;/Header&gt;
        &lt;Content class=&quot;doc-layout-content&quot;&gt;content&lt;/Content&gt;
        &lt;Footer class=&quot;doc-layout-footer&quot;&gt;footer&lt;/Footer&gt;
    &lt;/Layout&gt;
    &lt;br&gt;
    &lt;Layout&gt;
        &lt;Header class=&quot;doc-layout-header&quot;&gt;header&lt;/Header&gt;
        &lt;Layout&gt;
            &lt;Sider class=&quot;doc-layout-sider&quot; hide-trigger&gt;sider&lt;/Sider&gt;
            &lt;Content class=&quot;doc-layout-content&quot;&gt;content&lt;/Content&gt;
        &lt;/Layout&gt;
        &lt;Footer class=&quot;doc-layout-footer&quot;&gt;footer&lt;/Footer&gt;
    &lt;/Layout&gt;
    &lt;br&gt;
    &lt;Layout&gt;
        &lt;Sider class=&quot;doc-layout-sider&quot; hide-trigger&gt;sider&lt;/Sider&gt;
        &lt;Layout&gt;
            &lt;Header class=&quot;doc-layout-header&quot;&gt;header&lt;/Header&gt;
            &lt;Content class=&quot;doc-layout-content&quot;&gt;content&lt;/Content&gt;
            &lt;Footer class=&quot;doc-layout-footer&quot;&gt;footer&lt;/Footer&gt;
        &lt;/Layout&gt;
    &lt;/Layout&gt;
    &lt;br&gt;
    &lt;Layout&gt;
        &lt;Header class=&quot;doc-layout-header&quot;&gt;header&lt;/Header&gt;
        &lt;Layout&gt;
            &lt;Sider class=&quot;doc-layout-sider&quot; hide-trigger&gt;sider&lt;/Sider&gt;
            &lt;Layout&gt;
                &lt;Content class=&quot;doc-layout-content&quot;&gt;content&lt;/Content&gt;
                &lt;Footer class=&quot;doc-layout-footer&quot;&gt;footer&lt;/Footer&gt;
            &lt;/Layout&gt;
        &lt;/Layout&gt;
    &lt;/Layout&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="ZDYD">
                <template slot="description"><p>通常这里可以设置LOGO</p>
</template>
                <template slot="title">自定义sider的header <a href="#ZDYD" data-title="自定义sider的header">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Layout&gt;
        &lt;Sider class=&quot;doc-layout-sider&quot; hide-trigger&gt;
            &lt;div slot=&quot;header&quot; class=&quot;doc-layout-sider-header&quot;&gt;
                LOGO
            &lt;/div&gt;
            sider
        &lt;/Sider&gt;
        &lt;Layout&gt;
            &lt;Header class=&quot;doc-layout-header&quot;&gt;header&lt;/Header&gt;
            &lt;Content class=&quot;doc-layout-content&quot;&gt;content&lt;/Content&gt;
            &lt;Footer class=&quot;doc-layout-footer&quot;&gt;footer&lt;/Footer&gt;
        &lt;/Layout&gt;
    &lt;/Layout&gt;
&lt;/template&gt;
&lt;style&gt;
    .doc-layout-header, .doc-layout-footer{
        background-color: #86d8af;
    }
    .doc-layout-content{
        min-height: 120px;
        line-height: 120px;
        background-color: #19be6b;
    }
    .doc-layout-sider{
        color: #ffffff;
        text-align: center;
        line-height: 120px;
        background-color: mix(#ffffff, #2d8cf0, 40%);
    }
     .doc-layout-sider-header{
        background-color: #02b7a5;
     }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="CBLBJ">
                <template slot="description"><p>默认 <code>Sider</code>组件显示trigger切换侧边栏的触发器，可以使用 <code>hide-trigger</code>属性隐藏触发器。</p>
<p>可设置 <code>Sider</code>组件 <code>height</code>属性使内部内容超出时滚动。</p>
<p>可设置 <code>Sider</code>组件 <code>collapsedWidth</code>属性收缩起来的宽度。当收起的宽度为0时，会自动出现特殊的trigger。</p>
<p>可通过 v-model双向绑定控制 <code>Sider</code>组件的展开收起状态。</p>
</template>
                <template slot="title">侧边栏布局 <a href="#CBLBJ" data-title="侧边栏布局">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<p></p>
<p></p>
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Layout&gt;
        &lt;Header class=&quot;doc-layout-header&quot;&gt;header&lt;/Header&gt;
        &lt;Layout&gt;
            &lt;Sider v-model=&quot;collapse&quot; 
                    :collapsed-width=&quot;collapsedWidth&quot;
                    :hide-trigger=&quot;hideTrigger&quot;&gt;
                &lt;Menu :collapse=&quot;collapse&quot; :collapsed-width=&quot;collapsedWidth&quot; theme=&quot;dark&quot;&gt;
                    &lt;MenuItem c-key=&quot;options1&quot;&gt;
                        &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                        &lt;span&gt;options1&lt;/span&gt;
                    &lt;/MenuItem&gt;
                    &lt;MenuItem c-key=&quot;options2&quot;&gt;
                        &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                        &lt;span&gt;options2&lt;/span&gt;
                    &lt;/MenuItem&gt;
                    &lt;MenuItem c-key=&quot;options3&quot;&gt;
                        &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                        &lt;span&gt;options3&lt;/span&gt;
                    &lt;/MenuItem&gt;
                &lt;/Menu&gt;
            &lt;/Sider&gt;
            &lt;Content class=&quot;doc-layout-content&quot;&gt;content&lt;/Content&gt;
        &lt;/Layout&gt;
        &lt;Footer class=&quot;doc-layout-footer&quot;&gt;footer&lt;/Footer&gt;
    &lt;/Layout&gt;
    &lt;br&gt;
    &lt;div&gt;
        &lt;m-switch width=&quot;90&quot; v-model=&quot;hideTrigger&quot;&gt;
            &lt;span slot=&quot;open&quot;&gt;显示trigger&lt;/span&gt;
            &lt;span slot=&quot;close&quot;&gt;隐藏trigger&lt;/span&gt;
        &lt;/m-switch&gt;
    &lt;/div&gt;
    &lt;br&gt;
    &lt;div&gt;定义收起的宽度： &lt;Input type=&quot;number&quot; v-model=&quot;collapsedWidth&quot;&gt;&lt;/Input&gt;&lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          collapse: true,
          collapsedWidth: 60,
          hideTrigger: false,
        }
      }
    }
&lt;/script&gt;
&lt;style&gt;
    .doc-layout-header, .doc-layout-footer{
        color: #ffffff;
        text-align: center;
        background-color: #86d8af;
    }
    .doc-layout-content{
        min-height: 120px;
        line-height: 120px;
        background-color: #19be6b;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="SZGD">
                <template slot="description"><p>默认情况下<code>sider</code>的高度是由内容撑开的</p>
</template>
                <template slot="title">设置高度 <a href="#SZGD" data-title="设置高度">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
 &lt;div&gt;
     &lt;div&gt;
         &lt;Layout&gt;
             &lt;Header class=&quot;doc-layout-header&quot;&gt;header&lt;/Header&gt;
             &lt;Layout&gt;
                 &lt;Sider height=&quot;300px&quot; v-model=&quot;collapse&quot;&gt;
                     &lt;Menu :collapse=&quot;collapse&quot; :open-keys=&quot;openKeys&quot; theme=&quot;dark&quot;&gt;
                         &lt;Submenu c-key=&quot;submenu1&quot;&gt;
                             &lt;template slot=&quot;title&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;submenu1&lt;/span&gt;
                             &lt;/template&gt;
                             &lt;MenuItem c-key=&quot;menuItem1&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem1&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem2&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem2&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem3&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem3&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem4&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem4&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem5&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem5&lt;/span&gt;
                             &lt;/MenuItem&gt;
                         &lt;/Submenu&gt;
                         &lt;Submenu c-key=&quot;submenu2&quot;&gt;
                             &lt;template slot=&quot;title&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;submenu2&lt;/span&gt;
                             &lt;/template&gt;
                             &lt;MenuItem c-key=&quot;menuItem2-1&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem2-1&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem2-2&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem2-2&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem2-3&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem2-3&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem2-4&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem2-4&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem2-5&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem2-5&lt;/span&gt;
                             &lt;/MenuItem&gt;
                         &lt;/Submenu&gt;
                         &lt;Submenu c-key=&quot;submenu3&quot;&gt;
                             &lt;template slot=&quot;title&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;submenu3&lt;/span&gt;
                             &lt;/template&gt;
                             &lt;MenuItem c-key=&quot;menuItem3-1&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem3-1&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem3-2&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem3-2&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem3-3&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem3-3&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem3-4&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem3-4&lt;/span&gt;
                             &lt;/MenuItem&gt;
                             &lt;MenuItem c-key=&quot;menuItem3-5&quot;&gt;
                                 &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                                 &lt;span&gt;menuItem3-5&lt;/span&gt;
                             &lt;/MenuItem&gt;
                         &lt;/Submenu&gt;
                     &lt;/Menu&gt;
                 &lt;/Sider&gt;
                 &lt;Content class=&quot;doc-layout-content&quot;&gt;content&lt;/Content&gt;
             &lt;/Layout&gt;
             &lt;Footer class=&quot;doc-layout-footer&quot;&gt;footer&lt;/Footer&gt;
         &lt;/Layout&gt;
     &lt;/div&gt;
 &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          collapse: false,
          openKeys: [],
        }
      }
    }
&lt;/script&gt;
&lt;style&gt;
    .doc-layout-header, .doc-layout-footer{
        color: #ffffff;
        text-align: center;
        background-color: #86d8af;
    }
    .doc-layout-content{
        min-height: 120px;
        line-height: 120px;
        background-color: #19be6b;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="ZDYCFQ">
                <template slot="description"><p>通过设置 <code>hide-trigger</code>属性隐藏默认的触发器。可自定义实现trigger触发器。</p>
</template>
                <template slot="title">自定义触发器 <a href="#ZDYCFQ" data-title="自定义触发器">#</a></template>
                <template slot="source"><monkey-view-demo4 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Layout&gt;
         &lt;Sider v-model=&quot;collapse&quot; hide-trigger&gt;
             &lt;Menu :collapse=&quot;collapse&quot; theme=&quot;dark&quot;&gt;
                 &lt;MenuItem c-key=&quot;options1&quot;&gt;
                      &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                      &lt;span&gt;options1&lt;/span&gt;
                 &lt;/MenuItem&gt;
                 &lt;MenuItem c-key=&quot;options2&quot;&gt;
                      &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                      &lt;span&gt;options2&lt;/span&gt;
                 &lt;/MenuItem&gt;
                 &lt;MenuItem c-key=&quot;options3&quot;&gt;
                      &lt;Icon type=&quot;home&quot;&gt;&lt;/Icon&gt;
                      &lt;span&gt;options3&lt;/span&gt;
                 &lt;/MenuItem&gt;
             &lt;/Menu&gt;
         &lt;/Sider&gt;
         &lt;Layout&gt;
             &lt;Header class=&quot;doc-layout-header&quot;&gt;
                 &lt;Icon type=&quot;list&quot; size=&quot;20&quot; @click=&quot;triggerClick&quot;&gt;&lt;/Icon&gt;
             &lt;/Header&gt;
             &lt;Content class=&quot;doc-layout-content&quot;&gt;content&lt;/Content&gt;
             &lt;Footer class=&quot;doc-layout-footer&quot;&gt;footer&lt;/Footer&gt;
         &lt;/Layout&gt;
     &lt;/Layout&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          collapse: false,
        }
      },
      methods: {
        triggerClick(){
          this.collapse = !this.collapse;
        }
      }
    }
&lt;/script&gt;
&lt;style&gt;
    .doc-layout-header, .doc-layout-footer{
        color: #ffffff;
        text-align: center;
        background-color: #86d8af;
    }
    .doc-layout-content{
        min-height: 120px;
        line-height: 120px;
        color: #ffffff;
        text-align: center;
        font-size: 16px;
        background-color: #19be6b;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="sider-props" class="anchor-title">Sider props <a class="header-anchor" href="#sider-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>Boolean</td>
<td>控制展开收起，可以使用v-model双向绑定，true(收起),false(展开)</td>
<td>-</td>
</tr>
<tr>
<td>width</td>
<td>String, Number</td>
<td>展开时的宽度</td>
<td>200</td>
</tr>
<tr>
<td>height</td>
<td>String, Number</td>
<td>设置滚动时的高度</td>
<td>-</td>
</tr>
<tr>
<td>collapsed-width</td>
<td>String, Number</td>
<td>收起时的宽度</td>
<td>60</td>
</tr>
<tr>
<td>hide-trigger</td>
<td>Boolean</td>
<td>是否隐藏trigger</td>
<td>-</td>
</tr>
<tr>
<td>show-zero-trigger</td>
<td>Boolean</td>
<td><code>collapsed-width</code>宽度为0时，是否显示特殊的trigger</td>
<td>true</td>
</tr>
</tbody>
</table>
<h3 id="sider-event" class="anchor-title">Sider event <a class="header-anchor" href="#sider-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>collapse</td>
<td>展开收起时触发</td>
<td>value</td>
</tr>
</tbody>
</table>
<h3 id="sider-slot" class="anchor-title">Sider slot <a class="header-anchor" href="#sider-slot">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>header</td>
<td>定义header</td>
</tr>
<tr>
<td>trigger</td>
<td>自定义trigger</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Layout',[_c('Header',{staticClass:"doc-layout-header"},[_vm._v("header")]),_vm._v(" "),_c('Content',{staticClass:"doc-layout-content"},[_vm._v("content")]),_vm._v(" "),_c('Footer',{staticClass:"doc-layout-footer"},[_vm._v("footer")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('Layout',[_c('Header',{staticClass:"doc-layout-header"},[_vm._v("header")]),_vm._v(" "),_c('Layout',[_c('Sider',{staticClass:"doc-layout-sider",attrs:{"hide-trigger":""}},[_vm._v("sider")]),_vm._v(" "),_c('Content',{staticClass:"doc-layout-content"},[_vm._v("content")])],1),_vm._v(" "),_c('Footer',{staticClass:"doc-layout-footer"},[_vm._v("footer")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('Layout',[_c('Sider',{staticClass:"doc-layout-sider",attrs:{"hide-trigger":""}},[_vm._v("sider")]),_vm._v(" "),_c('Layout',[_c('Header',{staticClass:"doc-layout-header"},[_vm._v("header")]),_vm._v(" "),_c('Content',{staticClass:"doc-layout-content"},[_vm._v("content")]),_vm._v(" "),_c('Footer',{staticClass:"doc-layout-footer"},[_vm._v("footer")])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('Layout',[_c('Header',{staticClass:"doc-layout-header"},[_vm._v("header")]),_vm._v(" "),_c('Layout',[_c('Sider',{staticClass:"doc-layout-sider",attrs:{"hide-trigger":""}},[_vm._v("sider")]),_vm._v(" "),_c('Layout',[_c('Content',{staticClass:"doc-layout-content"},[_vm._v("content")]),_vm._v(" "),_c('Footer',{staticClass:"doc-layout-footer"},[_vm._v("footer")])],1)],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Layout',[_c('Sider',{staticClass:"doc-layout-sider",attrs:{"hide-trigger":""}},[_c('div',{staticClass:"doc-layout-sider-header",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                LOGO\n            ")]),_vm._v("\n            sider\n        ")]),_vm._v(" "),_c('Layout',[_c('Header',{staticClass:"doc-layout-header"},[_vm._v("header")]),_vm._v(" "),_c('Content',{staticClass:"doc-layout-content"},[_vm._v("content")]),_vm._v(" "),_c('Footer',{staticClass:"doc-layout-footer"},[_vm._v("footer")])],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Layout',[_c('Header',{staticClass:"doc-layout-header"},[_vm._v("header")]),_vm._v(" "),_c('Layout',[_c('Sider',{attrs:{"collapsed-width":_vm.collapsedWidth,"hide-trigger":_vm.hideTrigger},model:{value:(_vm.collapse),callback:function ($$v) {_vm.collapse=$$v},expression:"collapse"}},[_c('Menu',{attrs:{"collapse":_vm.collapse,"collapsed-width":_vm.collapsedWidth,"theme":"dark"}},[_c('MenuItem',{attrs:{"c-key":"options1"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("options1")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"options2"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("options2")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"options3"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("options3")])],1)],1)],1),_vm._v(" "),_c('Content',{staticClass:"doc-layout-content"},[_vm._v("content")])],1),_vm._v(" "),_c('Footer',{staticClass:"doc-layout-footer"},[_vm._v("footer")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('m-switch',{attrs:{"width":"90"},model:{value:(_vm.hideTrigger),callback:function ($$v) {_vm.hideTrigger=$$v},expression:"hideTrigger"}},[_c('span',{attrs:{"slot":"open"},slot:"open"},[_vm._v("显示trigger")]),_vm._v(" "),_c('span',{attrs:{"slot":"close"},slot:"close"},[_vm._v("隐藏trigger")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("定义收起的宽度： "),_c('Input',{attrs:{"type":"number"},model:{value:(_vm.collapsedWidth),callback:function ($$v) {_vm.collapsedWidth=$$v},expression:"collapsedWidth"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          collapse: true,
          collapsedWidth: 60,
          hideTrigger: false,
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('div',[_c('Layout',[_c('Header',{staticClass:"doc-layout-header"},[_vm._v("header")]),_vm._v(" "),_c('Layout',[_c('Sider',{attrs:{"height":"300px"},model:{value:(_vm.collapse),callback:function ($$v) {_vm.collapse=$$v},expression:"collapse"}},[_c('Menu',{attrs:{"collapse":_vm.collapse,"open-keys":_vm.openKeys,"theme":"dark"}},[_c('Submenu',{attrs:{"c-key":"submenu1"}},[_c('template',{slot:"title"},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("submenu1")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem1"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem1")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem2"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem2")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem3"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem3")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem4"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem4")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem5"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem5")])],1)],2),_vm._v(" "),_c('Submenu',{attrs:{"c-key":"submenu2"}},[_c('template',{slot:"title"},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("submenu2")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem2-1"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem2-1")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem2-2"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem2-2")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem2-3"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem2-3")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem2-4"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem2-4")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem2-5"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem2-5")])],1)],2),_vm._v(" "),_c('Submenu',{attrs:{"c-key":"submenu3"}},[_c('template',{slot:"title"},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("submenu3")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem3-1"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem3-1")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem3-2"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem3-2")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem3-3"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem3-3")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem3-4"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem3-4")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"menuItem3-5"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("menuItem3-5")])],1)],2)],1)],1),_vm._v(" "),_c('Content',{staticClass:"doc-layout-content"},[_vm._v("content")])],1),_vm._v(" "),_c('Footer',{staticClass:"doc-layout-footer"},[_vm._v("footer")])],1)],1)])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          collapse: false,
          openKeys: [],
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Layout',[_c('Sider',{attrs:{"hide-trigger":""},model:{value:(_vm.collapse),callback:function ($$v) {_vm.collapse=$$v},expression:"collapse"}},[_c('Menu',{attrs:{"collapse":_vm.collapse,"theme":"dark"}},[_c('MenuItem',{attrs:{"c-key":"options1"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("options1")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"options2"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("options2")])],1),_vm._v(" "),_c('MenuItem',{attrs:{"c-key":"options3"}},[_c('Icon',{attrs:{"type":"home"}}),_vm._v(" "),_c('span',[_vm._v("options3")])],1)],1)],1),_vm._v(" "),_c('Layout',[_c('Header',{staticClass:"doc-layout-header"},[_c('Icon',{attrs:{"type":"list","size":"20"},on:{"click":_vm.triggerClick}})],1),_vm._v(" "),_c('Content',{staticClass:"doc-layout-content"},[_vm._v("content")]),_vm._v(" "),_c('Footer',{staticClass:"doc-layout-footer"},[_vm._v("footer")])],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          collapse: false,
        }
      },
      methods: {
        triggerClick(){
          this.collapse = !this.collapse;
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  